// extracted by mini-css-extract-plugin
export var equalColumn = "_jb-0";